import { useMemo } from 'react';
import { userSettingsPropertySelector } from '../selectors/userSettings';
import { IUserSettings } from '../slices/userSettings';
import { useAppSelector } from '../hooks';

export default <T extends keyof IUserSettings>(key: T) => {
  const memoizedSelector = useMemo(() => userSettingsPropertySelector<T>(), []);

  return useAppSelector((state) => memoizedSelector(state, key));
};
